/**
 * Evaluation Data Hooks
 * 평가결과 API React Query 훅
 */

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getClassEvaluation } from '../../services/evaluationService';
import type {
	GetClassEvaluationParams,
	GetClassEvaluationResponseDto,
} from '../../types/api/evaluation';

export const evaluationKeys = {
	all: ['evaluation'] as const,
	classEvaluations: () => [...evaluationKeys.all, 'class-evaluation'] as const,
	classEvaluation: (classId: number, params?: GetClassEvaluationParams) => 
		[...evaluationKeys.classEvaluations(), classId, params] as const,
};

/**
 * 클래스 평가결과 조회 훅
 * 
 * @param classId - Class ID
 * @param params - Query Parameters (Optional)
 * @param options - React Query Options
 */
export const useClassEvaluation = (
	classId: number,
	params?: GetClassEvaluationParams,
	options?: Omit<UseQueryOptions<GetClassEvaluationResponseDto>, 'queryKey' | 'queryFn'>
) => {
	return useQuery({
		queryKey: evaluationKeys.classEvaluation(classId, params),
		queryFn: () => getClassEvaluation(classId, params),
		staleTime: 30_000, // 30초
		refetchOnMount: true,
		enabled: options?.enabled !== false && classId > 0,
		...options,
	});
};
